import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly defaultLoaderConfig = {
    busy: true,
    delay: 0,
    minDuration: 0,
    message: 'BMC',
    loaderType: 'app',
    overlayClass: 'cmxa-overlay-backdrop'
  };

  private sourceOnAddLoader: BehaviorSubject<any> = new BehaviorSubject<any>(this.defaultLoaderConfig);
  public onToggleLoader = this.sourceOnAddLoader.asObservable();

  public toggleLoader(busyStatus: boolean): void {
    const newLoaderConfig = {
      ...this.defaultLoaderConfig,
      busy: busyStatus
    };
    this.sourceOnAddLoader.next(newLoaderConfig);
  }
}
